module.exports = __webpack_public_path__ + "assets/nps.1c2201bf.svg";